import { render } from "./gfk-footer.vue?vue&type=template&id=04b3a775"
import script from "./gfk-footer.vue?vue&type=script&lang=js"
export * from "./gfk-footer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__